import { Card, CardContent } from '@/components/ui/card';
import { formatCurrency } from '@/lib/expense-utils';
import { useExpenseSummary } from '@/hooks/use-expenses';
import { Skeleton } from '@/components/ui/skeleton';

export function ExpenseSummaryCards() {
  const { data: summary, isLoading } = useExpenseSummary();

  if (isLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Card key={i}>
            <CardContent className="p-6">
              <Skeleton className="h-4 w-24 mb-2" />
              <Skeleton className="h-8 w-32" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (!summary) return null;

  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Card className="border-destructive/20 bg-destructive/5">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Total vencido</p>
              <h3 className="text-2xl font-bold text-destructive">
                {formatCurrency(summary.overdue.total)}
              </h3>
            </div>
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-destructive/10">
              <span className="text-lg font-bold text-destructive">{summary.overdue.count}</span>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="border-chart-4/20 bg-chart-4/5">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Total a vencer</p>
              <h3 className="text-2xl font-bold" style={{ color: 'hsl(var(--chart-4))' }}>
                {formatCurrency(summary.pending.total)}
              </h3>
            </div>
            <div className="flex h-10 w-10 items-center justify-center rounded-full" style={{ backgroundColor: 'hsl(var(--chart-4) / 0.1)' }}>
              <span className="text-lg font-bold" style={{ color: 'hsl(var(--chart-4))' }}>{summary.pending.count}</span>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="border-chart-2/20 bg-chart-2/5">
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Total pago</p>
              <h3 className="text-2xl font-bold" style={{ color: 'hsl(var(--chart-2))' }}>
                {formatCurrency(summary.paid.total)}
              </h3>
            </div>
            <div className="flex h-10 w-10 items-center justify-center rounded-full" style={{ backgroundColor: 'hsl(var(--chart-2) / 0.1)' }}>
              <span className="text-lg font-bold" style={{ color: 'hsl(var(--chart-2))' }}>{summary.paid.count}</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
